import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = 'XPLOD GROUPS - Professional Power Tools & Garden Equipment',
  description = 'Official website of XPLOD-GROUPS™. Shop professional power tools, garden tools, chainsaws, blowers, and more. Quality equipment with expert support.',
  keywords = 'power tools, garden tools, chainsaws, blowers, STIHL, professional tools, outdoor equipment, lawn care, Kerala',
  canonical = '',
  image = 'https://res.cloudinary.com/dmyb3ffz9/image/upload/v1756269583/image_1_wfi4lf.webp',
  type = 'website',
  structuredData = null,
  productData = null,
}) => {
  const siteUrl = 'https://xplodgroups.com';
  const fullUrl = canonical ? `${siteUrl}${canonical}` : siteUrl;
  const fullImageUrl = image.startsWith('http') ? image : `${siteUrl}${image}`;

  const defaultStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'XPLOD GROUPS',
    description: 'Professional power tools and garden equipment supplier',
    url: siteUrl,
    logo: fullImageUrl,
    sameAs: [
      'https://www.facebook.com/xplodgroups',
      'https://www.instagram.com/xplodgroups',
    ],
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+91-9446189273',
      contactType: 'customer service',
      areaServed: 'IN',
      availableLanguage: ['en', 'Malayalam'],
    },
  };

  let finalStructuredData = structuredData || defaultStructuredData;

  if (productData) {
    finalStructuredData = {
      '@context': 'https://schema.org',
      '@type': 'Product',
      name: productData.name,
      description: productData.description || description,
      image: productData.images || [fullImageUrl],
      brand: {
        '@type': 'Brand',
        name: productData.brand || 'STIHL',
      },
      sku: productData.sku || productData.id,
      offers: {
        '@type': 'Offer',
        url: fullUrl,
        priceCurrency: 'INR',
        price: productData.price || '0',
        availability: productData.inStock
          ? 'https://schema.org/InStock'
          : 'https://schema.org/OutOfStock',
        seller: {
          '@type': 'Organization',
          name: 'XPLOD GROUPS',
        },
      },
      aggregateRating: productData.rating
        ? {
            '@type': 'AggregateRating',
            ratingValue: productData.rating,
            reviewCount: productData.reviewCount || 1,
          }
        : undefined,
    };
  }

  return (
    <Helmet>
      <html lang="en" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={fullUrl} />

      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImageUrl} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:site_name" content="XPLOD GROUPS" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImageUrl} />

      <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow" />

      <meta property="og:locale" content="en_IN" />
      <meta name="geo.region" content="IN-KL" />
      <meta name="geo.placename" content="Kerala" />

      <script type="application/ld+json">
        {JSON.stringify(finalStructuredData)}
      </script>
    </Helmet>
  );
};

export default SEO;
